import { cesiumContentHeaderSize } from './header';
import { CesiumContentFeatures, CesiumContentHeader } from './types';

export const extractFeatureAndBatchTable = (
  pntsBuffer: ArrayBuffer,
  cesiumContentHeader: CesiumContentHeader,
): CesiumContentFeatures => {
  const featureTableEndOffset =
    cesiumContentHeaderSize + cesiumContentHeader.featureTableJSONLength;
  const featureBinaryEndOffset =
    featureTableEndOffset + cesiumContentHeader.featureTableBinaryByteLength;
  const batchTableEndOffset = featureBinaryEndOffset + cesiumContentHeader.batchTableJSONByteLength;
  const batchBinaryEndOffset = batchTableEndOffset + cesiumContentHeader.batchTableBinaryByteLength;

  // Extract feature table JSON (from header end to feature table end)
  const featureTableBuffer = pntsBuffer.slice(cesiumContentHeaderSize, featureTableEndOffset);
  const featureTable = JSON.parse(new TextDecoder().decode(featureTableBuffer));

  // Extract feature binary body (from feature table end to feature binary end)
  const featureBody = pntsBuffer.slice(featureTableEndOffset, featureBinaryEndOffset);

  let batchTable: any = undefined;
  let batchBody: ArrayBuffer | undefined = undefined;
  const containBatchData =
    cesiumContentHeader.batchTableJSONByteLength > 0 &&
    cesiumContentHeader.batchTableBinaryByteLength > 0 &&
    pntsBuffer.byteLength === batchBinaryEndOffset;
  if (containBatchData) {
    // Extract batch table JSON (from feature binary end to batch table end)
    const batchTableBuffer = pntsBuffer.slice(featureBinaryEndOffset, batchTableEndOffset);
    batchTable = JSON.parse(new TextDecoder().decode(batchTableBuffer));
    // Extract batch binary body (from batch table end to end of buffer)
    batchBody = pntsBuffer.slice(batchTableEndOffset, batchBinaryEndOffset);
  }

  return { featureTable, featureBody, batchTable, batchBody };
};
